import { useContext } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TableFooter } from '@mui/material';
import { customerTicketsContext } from '../../CustomerTicketsContext';
import { CircleLoader, ClickableTableRow } from 'components';
import { useHistory } from 'react-router-dom';
import { customerApplicationContext } from 'helpers/services';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { localeContext } from 'helpers/Locale/LocaleManager';


let Results = () => {
    let history = useHistory();
    let { formatMessage } = useIntl();

    let { currentLocale } = useContext(localeContext);
    let { getCategoryById, getSubCategoryById } = useContext(customerApplicationContext);

    let service = useContext(customerTicketsContext);


    return <>
        {service.isLoading && <CircleLoader />}
        {service.isLoading === false &&
            <>
                <PerfectScrollbar>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{formatMessage({ id: LocalizationIds.Ticket })}</TableCell>
                                <TableCell>{formatMessage({ id: LocalizationIds.Priority })}</TableCell>
                                <TableCell>{formatMessage({ id: LocalizationIds.Status })}</TableCell>
                                <TableCell>{formatMessage({ id: LocalizationIds.Title })}</TableCell>
                                <TableCell>{formatMessage({ id: LocalizationIds.AssignedTo })}</TableCell>
                                <TableCell align="right" />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {service.tickets.map((ticket, index) =>
                                <ClickableTableRow
                                    hover
                                    key={index}
                                    onClick={() => history.push(`/customer/ticket/edit/${ticket.number}`)}
                                >
                                    <TableCell><b>{ticket.number}</b></TableCell>
                                    <TableCell>{ticket.ticketPriority}</TableCell>
                                    <TableCell>
                                        {ticket.ticketStatus[currentLocale]}
                                        <div style={{ color: getCategoryById(ticket.categoryId)?.color ?? undefined }}>
                                            {`${getCategoryById(ticket.categoryId)?.names[currentLocale]} / ${getSubCategoryById(ticket.ticketSubCategoryId)?.names[currentLocale]}`}
                                        </div>
                                    </TableCell>
                                    <TableCell>{ticket.title}<br />{ticket.customerName}</TableCell>
                                    <TableCell>
                                        {ticket.assigneeUser != null ?
                                            <> {ticket.assigneeUser} </>
                                            : <> {formatMessage({ id: LocalizationIds.NotAssigned })} </>
                                        }
                                    </TableCell>
                                    <TableCell />
                                </ClickableTableRow>
                            )}
                        </TableBody>
                        {service.isLoading === false && service.tickets.length === 0 &&
                            <TableFooter>
                                <TableRow>
                                    <TableCell colSpan={6}>
                                        <i>{formatMessage({ id: LocalizationIds.NoDataFound })}</i>
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        }
                    </Table>
                </PerfectScrollbar>

                <TablePagination
                    component="div"
                    count={service.recordCount}
                    onPageChange={service.handleChangePage}
                    page={service.search.pageNr}
                    rowsPerPage={service.search.pageSize}
                    rowsPerPageOptions={[service.search.pageSize]}
                    labelDisplayedRows={({ page, count }) =>
                        <>
                            {formatMessage({ id: LocalizationIds.TotalTickets })}:&nbsp;{service.recordCount} &nbsp;&middot;&nbsp;
                            {formatMessage(
                                { id: LocalizationIds.PageOf },
                                { pageNr: page + 1, count: Math.ceil(count / service.search.pageSize) }
                            )}
                        </>
                    }
                />
            </>
        }
    </>;
}

export default Results;